import { useQuery } from "@tanstack/react-query";
import { ContentError, getPost, getPostV2, isTypedPost, type WallPost } from "../api/content";

export const wallPostKey = (id: string | null) => ["wallPost", id] as const;

/**
 * A post by ULID. v1 post routes are WALL-only (room-stc ScopeWall): a typed post the caller already knows (the tapped
 * card) reads through v2 only; otherwise v1 first (a WALL post keeps its captionFallback), then v2 when v1 answers
 * NOT_FOUND (a NEWS / EVENT… post opened from a copied link).
 */
async function getUlidPost(id: string, known?: { type?: string | null }): Promise<WallPost> {
  if (known && isTypedPost(known)) return getPostV2(id);
  try {
    return await getPost(id);
  } catch (e) {
    if (e instanceof ContentError && e.code === "NOT_FOUND") return getPostV2(id);
    throw e;
  }
}

/** One post by ULID; `initial` is the card the user tapped, refreshed on mount. */
export function useWallPost(id: string | null, initial?: WallPost) {
  return useQuery({
    queryKey: wallPostKey(id),
    queryFn: () => getUlidPost(id as string, initial as { type?: string } | undefined),
    enabled: id != null,
    initialData: initial,
    retry: false,
  });
}
